import { makeDataErrorMessages } from '@atlassian/amkt-common';
import { initializeBackends as initializeAnalyticsBackends } from '../../analytics/Send';
export const ANALYTICS_LOADED_SUCCESS = 'ANALYTICS_ANALYTICS_LOADED_SUCCESS';
export const ANALYTICS_LOADED_ERROR = 'ANALYTICS_ANALYTICS_LOADED_ERROR';
export const ANALYTICS_SEND_PAGE_VIEW = 'ANALYTICS_SEND_PAGE_VIEW';
export const ANALYTICS_DONE_PAGE_VIEW = 'ANALYTICS_DONE_PAGE_VIEW';
export const ANALYTICS_SCREEN_CHANGED = 'ANALYTICS_SCREEN_CHANGED';
export const ANALYTICS_MODAL_OPENED = 'ANALYTICS_MODAL_OPENED';
export const ANALYTICS_MODAL_CLOSED = 'ANALYTICS_MODAL_CLOSED';
const analyticsLoadedSuccess = () => ({
  type: ANALYTICS_LOADED_SUCCESS
});
const analyticsLoadedError = _ref => {
  let {
    dataErrorMessages
  } = _ref;
  return {
    type: ANALYTICS_LOADED_ERROR,
    dataErrorMessages
  };
};
const screenChanged = _ref2 => {
  let {
    screen,
    attributes
  } = _ref2;
  return {
    type: ANALYTICS_SCREEN_CHANGED,
    screen,
    attributes
  };
};
const modalOpened = _ref3 => {
  let {
    modal
  } = _ref3;
  return {
    type: ANALYTICS_MODAL_OPENED,
    modal
  };
};
const modalClosed = _ref4 => {
  let {
    modal
  } = _ref4;
  return {
    type: ANALYTICS_MODAL_CLOSED,
    modal
  };
};
const pageViewEvent = () => ({
  type: ANALYTICS_SEND_PAGE_VIEW
});
export const doInitializeAnalytics = _ref5 => {
  let {
    hostInfo,
    currentUserId
  } = _ref5;
  return dispatch => initializeAnalyticsBackends(hostInfo, currentUserId).then(() => {
    dispatch(analyticsLoadedSuccess());
  }, error => {
    dispatch(analyticsLoadedError({
      dataErrorMessages: makeDataErrorMessages([error])
    }));
  });
};
export const onModalOpened = modal => dispatch => {
  dispatch(modalOpened({
    modal
  }));
  dispatch(pageViewEvent());
};
export const onModalClosed = modal => dispatch => {
  dispatch(modalClosed({
    modal
  }));
  setTimeout(() => dispatch(pageViewEvent()), 500);
};
export const onScreenChanged = (screen, attributes) => dispatch => {
  dispatch(screenChanged({
    screen,
    attributes
  }));
  dispatch(pageViewEvent());
};